import { MiddlewareAPI } from "@reduxjs/toolkit";
import { AppDispatch, RootState } from "@/store";
import { Socket } from "socket.io-client";
import { Logger } from "roarr";
import { JsonObject } from "roarr/dist/types";
import { GenParams } from "./GenParams";
import { buildTextToImageParam } from "./buildTextToImageParam";
import { buildEsrganParam } from "./buildEsrganParam";
import { progressImageSet, setCurrentImage } from "@/reducer/designslice";
import { SaveContent } from "@/types/content";
import Client4 from "@/services/api/client4";
import { contentAdd } from "@/reducer/contentSlice";
import { updateUser } from "@/reducer/userslice";

type SetEventListenersArg = {
  socket: Socket;
  storeApi: MiddlewareAPI<AppDispatch, RootState>;
  log: Logger<JsonObject>;
};

export const setEventListeners = (arg: SetEventListenersArg) => {
  const { socket, storeApi, log } = arg;
  const { dispatch, getState } = storeApi;
  let imgNum: number;
  let imgCount: number;
  let params: GenParams;

  socket.on("connect", async () => {
    log.debug("Connected");
    const state = getState();
    const currentGen = state.mode.currentGen;

    if (currentGen === "TXT2IMG") {
      params = await buildTextToImageParam(state);
    } else if (currentGen === "ESRGAN") {
      params = await buildEsrganParam(state);
    } else {
      socket.disconnect();
      return;
    }

    imgNum = params.n_iter;
    imgCount = 0;
    socket.emit("gen-request", params);
  });

  socket.on("gen-answer", async (data) => {
    const state = getState();
    const userId = state.users.user.id;
    const prompt = params?.prompt;

    const saveParams = {
      user_id: userId,
      prompt,
      negative_prompt: params?.negative_prompt || "",
      ref_structure: params?.refStructure || "",
      ref_structure_weight: params.refStructureWeight,
      ref_structure_type: params.refStructureType,
      control_mode: params.control_mode,
      ref_style: params?.refStyle || "",
      ref_style_weight: params.refStyleWeight,
      width: params?.width || 0,
      height: params?.height || 0,
      nums: params.n_iter,
      steps: params.steps,
      seed: params.seed,
      style: params?.style || "",
      sd_model_checkpoint: params.sd_model_checkpoint,
      lora: params.lora,
      vae: params.vae,
      cfgscale: params.cfgscale,
      type: params?.type || "",
      generate_type: params?.generateType || "",
      mode: params.mode,
      thumbnail_url: data.thumbnail_url,
      image_url: data.image_url,
      image_name: data.file_name,
    };

    try {
      const result = await Client4.saveContent(saveParams as SaveContent);
      dispatch(contentAdd(result));
      dispatch(setCurrentImage(result));
      imgCount += 1;

      if (imgCount === imgNum) {
        const amount = state.mode.amount;
        const payData = {
          amount,
          type: "生图",
          detail: "您生成了" + params.n_iter + "张图",
          userId,
        };
        const res = await Client4.postPay(payData);
        if (res) {
          const userInfo = await Client4.getMe();
          dispatch(updateUser(userInfo));
        }
        socket.disconnect();
        dispatch(progressImageSet(null));
      }
    } catch (error) {
      return error;
    }
  });

  socket.on("connect_error", (error) => {
    if (error && error.message) {
      const data: string | undefined = (error as any).data;
      if (data === "ERR_UNAUTHENTICATED") {
        return;
      }
    }
  });

  socket.on("disconnect", () => {});
};
